import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { WA_LINK } from '../lib/constants';
export function FinalCTA() {
  return <section className="bg-brand-light py-24" data-id="element-26">
      <div className="container mx-auto px-4 md:px-6" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mx-auto max-w-4xl text-center" data-id="element-28">
          <h2 className="mb-6 text-4xl font-bold tracking-tight text-brand-dark sm:text-5xl" data-id="element-29">
            ¿Necesitas orientación dental clara y directa?
          </h2>
          <p className="mx-auto mb-10 max-w-2xl text-xl text-slate-600" data-id="element-30">
            Escríbenos por WhatsApp y cuéntanos qué necesitas. Te orientamos
            para saber cómo avanzar con tu atención dental.
          </p>
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 rounded-full bg-brand-accent px-10 py-5 text-lg font-bold text-white shadow-xl transition-all hover:bg-brand-accentHover hover:shadow-2xl hover:-translate-y-1" data-id="element-31">
            <MessageCircle size={24} data-id="element-32" />
            Hablar por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}